import { forwardRef, useImperativeHandle } from "react"
import { useNavigate } from "react-router-dom"

//hooks
import useOpenWindow from "hooks/useOpenWindow"
import useIsLoading from "hooks/useIsLoading"

//images
import questionIcon from "assets/images/app/icons/question.svg"

//helpers
import { getUrlExeptPassedParam } from "helpers/url"

function RemoveModal(
  { accept, elementsContent, closeEditWhenFinish, param },
  ref
) {
  const { setLoading, loading } = useIsLoading()
  const { buttons, heading, text } = {
    buttons: {
      cancel: null,
      accept: null,
    },
    heading: null,
    text: null,
    ...elementsContent,
  }

  const { handleClose, handleOpen, isOpened } = useOpenWindow()

  const navigate = useNavigate()

  useImperativeHandle(ref, () => ({
    open: handleOpen,
    close: () => {
      closeWindow()
      setLoading(false)
      if (closeEditWhenFinish) {
        navigate({
          search: getUrlExeptPassedParam("edit"),
        })
      }
    },
  }))

  function handleAccept() {
    setLoading(true)
    accept()
  }

  function closeWindow() {
    handleClose()
    navigate({
      search: getUrlExeptPassedParam(param),
    })
  }

  return (
    <div className={`overlay question-overlay ${isOpened() ? "show" : ""}`}>
      <div className="modal">
        <div className="body">
          <img src={questionIcon} className="main" alt="" />
          <b>{heading || "Сигурни ли сте, че искате да продължите?"}</b>
          <p>{text || "Предприетите от Вас действия може да са необратими."}</p>
        </div>
        <div className="buttons">
          <button className="btn-secondary" onClick={closeWindow}>
            {buttons.cancel || "Отказ"}
          </button>
          <button
            onClick={handleAccept}
            className={`btn-primary ${loading ? "loading" : ""}`}
          >
            {buttons.accept || "Да"}
          </button>
        </div>
      </div>
    </div>
  )
}

export default forwardRef(RemoveModal)
